import { render } from "./PrimaryInsurance.vue?vue&type=template&id=73c032a1"
import script from "./PrimaryInsurance.vue?vue&type=script&lang=js"
export * from "./PrimaryInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/billingInfo/forms/PrimaryInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73c032a1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73c032a1', __exports__)) {
    console.log('reload')
    api.reload('73c032a1', __exports__)
  }
  
  module.hot.accept("./PrimaryInsurance.vue?vue&type=template&id=73c032a1", () => {
    console.log('re-render')
    api.rerender('73c032a1', render)
  })

}


export default __exports__